import React, { useEffect, useState } from 'react';
import { Info } from '@phosphor-icons/react';
import { getSystemInfo } from '../services/api';

// Cached across the SPA lifetime so we don't ping /system/info on every navigation.
let _cached = null;
let _inflight = null;
const fetchOnce = () => {
  if (_cached !== null) return Promise.resolve(_cached);
  if (!_inflight) {
    _inflight = getSystemInfo()
      .then((res) => { _cached = res.data || {}; return _cached; })
      .catch(() => { _cached = {}; return _cached; });
  }
  return _inflight;
};

/**
 * Renders a "DEMO MODE" banner across the top of the screen whenever the
 * backend reports DEMO_MODE=true. Used by the public sandbox tenant linked
 * from the portfolio / case-study page. In production this component is
 * invisible (renders null).
 */
const DemoBanner = () => {
  const [demo, setDemo] = useState(false);

  useEffect(() => {
    let mounted = true;
    fetchOnce().then((info) => { if (mounted) setDemo(!!info?.demo_mode); });
    return () => { mounted = false; };
  }, []);

  if (!demo) return null;

  return (
    <div
      data-testid="demo-mode-banner"
      className="w-full bg-amber-400 text-amber-950 text-xs sm:text-sm font-semibold flex items-center justify-center gap-2 px-3 py-1.5 border-b border-amber-500"
      style={{ letterSpacing: '0.02em' }}
    >
      <Info weight="fill" className="w-4 h-4 flex-shrink-0" />
      <span>
        DEMO MODE — emails, Telegram, Zapier and Terminal49 are <strong>suppressed</strong>.
        Data may reset automatically.
      </span>
    </div>
  );
};

export default DemoBanner;
